import * as THREE from 'three';
import React, { useEffect } from "react";
import { useGLTF, useTexture } from "@react-three/drei";
import { useLoading } from '../context/LoadingContext';

function Model(props) {
  const { nodes, materials } = useGLTF("/models/iphone_16_pro.glb");
  const texture = useTexture(props.item.img);
  const { markTechnicalLoadComplete } = useLoading();

  useEffect(() => {
    // 1. Signal loading complete
    markTechnicalLoadComplete();

    // 2. Apply body colors
    // The new model uses 'phone16pro' as the main material
    if (materials.phone16pro) {
      materials.phone16pro.color = new THREE.Color(props.item.color[0]);
      materials.phone16pro.needsUpdate = true;
    }

    // 3. Handle Transparent parts (optional tint?)
    if (materials.phone16pro_transparent) {
      // Maybe keep it as is or tint slightly?
      // materials.phone16pro_transparent.color = new THREE.Color(props.item.color[0]);
    }

    // NOTE: This model does not have a separate 'wallpaper' or 'screen' material slot visible in the export.
    // Texture mapping is skipped to avoid covering the whole phone.

  }, [materials, props.item, texture, markTechnicalLoadComplete]);

  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.Object_6.geometry} material={materials.phone16pro} />
      <mesh geometry={nodes.Object_9.geometry} material={materials.phone16pro} />
      <mesh geometry={nodes.Object_12.geometry} material={materials.phone16pro_transparent} />
      <mesh geometry={nodes.Object_15.geometry} material={materials.phone16pro} />
    </group>
  );
}

export default Model;

useGLTF.preload("/models/iphone_16_pro.glb");
